<template>
  <v-flex xs12 row>
	<v-layout py-3>
   		<v-flex xs12 md4 offset-md4 v-if="passwordEditMode">
   			<v-form v-model="validPasswordForm">
		        <v-card>
		          <v-card-title>
		            <span class="headline">Update Password</span>
		          </v-card-title>

		          <v-card-text>
		            <v-container grid-list-md py-0>
		              	<v-layout wrap>
			                <v-flex xs12>
			                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :append-icon="showPasswords ? 'visibility_off' : 'visibility'" :type="showPasswords ? 'text' : 'password'" v-model="passwords.old_password" label="Current Password" @click:append="showPasswords = !showPasswords"></v-text-field>
			                </v-flex>
			                <v-flex xs12>
			                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :type="showPasswords ? 'text' : 'password'" v-model="passwords.new_password" label="New Password"></v-text-field>
			                </v-flex>
			                <v-flex xs12>
			                  <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :type="showPasswords ? 'text' : 'password'" v-model="passwords.new_password1" label="Re-enter Password"></v-text-field>
			                </v-flex>
		              	</v-layout>
		            </v-container>
		          </v-card-text>

		          <v-card-actions>
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" :disabled="processing" flat @click="passwordEditMode = false">Cancel</v-btn>
	                <v-btn color="blue darken-1" flat :disabled="!validPasswordForm || processing" :loading="processing" @click.native="updatePassword">Change Password</v-btn>
		          </v-card-actions>
		        </v-card>
		      </v-form>
   		</v-flex>
   		<v-flex xs12 md6 offset-md3 v-else>
   			<v-form v-model="validForm">
		        <v-card>
		          <v-card-title v-if="editMode">
		            <span class="headline">Update Profile</span>
		          </v-card-title>

		          <v-card-text>
		            <v-container grid-list-md py-0>
		              	<v-layout wrap v-if="editMode">
			                <v-flex xs12 sm6>
			                  <v-text-field :rules="fNameRules" counter="50" v-model="item.first_name" label="First Name"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-text-field counter="50" maxlength="50" v-model="item.last_name" label="Last Name"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-text-field :readonly="readonly" :rules="uNameRules" counter="25" v-model="item.username" label="Username"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6 md6>
			                  <v-text-field :rules="emailRules" counter="50" v-model="item.email" label="Email"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-text-field :rules="mobileRules" mask="#### ### ###" counter="10" v-model="item.mobile" label="Mobile"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                	<v-autocomplete :rules="requireRule" v-model="item.country" :items="countries" item-text="country" item-value="id" label="Country"></v-autocomplete>
			                </v-flex>
			                <v-flex xs12 sm6>
			                	<v-autocomplete :rules="requireRule" v-model="item.province" :items="states" item-text="state" item-value="id" label="State"></v-autocomplete>
			                </v-flex>
			                <v-flex xs12 sm6>
			                	<v-autocomplete :rules="requireRule" v-model="item.city" :items="cities" item-text="city" item-value="id" label="City"></v-autocomplete>
			                </v-flex>
			                <v-flex xs12 sm6>
			                	<v-text-field :readonly="readonly" v-model="item.role" label="Role"></v-text-field>
			                </v-flex>
		              	</v-layout>
		              	<v-layout wrap v-else class="pb-3">
		              		
		              		<v-flex xs12 pt-3 text-xs-center>
						        <v-avatar size="150px" color="grey lighten-4">
						          <img src="../assets/images/face-icon.png" alt="avatar">
						        </v-avatar>
						        <div class="text-xs-center pt-2">
						        	<div class="title">{{fullname}}</div>
						        	<div class="body-1">{{loggedInUser.role}}</div>
						        </div>

						        <div>
						        	<v-btn color="blue darken-1" :disabled="processing" class="caption" flat @click="editMode = true">Edit Profile</v-btn>
	                				<v-btn color="blue darken-1" :disabled="processing" class="caption" flat @click="passwordEditMode = true">Change Password</v-btn>
						        </div>

						        <v-divider></v-divider>
						    </v-flex>

			                <v-flex xs12 sm6 class="pt-3">
			                	<label class="caption font-weight-light grey--text">Role</label>
			                  	<div class="subheading">{{item.role}}</div>
			                </v-flex>

			                <v-flex xs12 sm6 class="pt-3">
			                	<label class="caption font-weight-light grey--text">Username</label>
			                  	<div class="subheading">{{item.username}}</div>
			                </v-flex>

			                <v-flex xs12 sm6 class="pt-3">
			                	<label class="caption font-weight-light grey--text">Email</label>
			                  	<div class="subheading">{{item.email}}</div>
			                </v-flex>

			                <v-flex xs12 sm6 class="pt-3">
			                	<label class="caption font-weight-light grey--text">Mobile</label>
			                  	<div class="subheading">{{item.mobile}}</div>
			                </v-flex>

			                <v-flex xs12 sm6 class="pt-3">
			                	<label class="caption font-weight-light grey--text">Country</label>
			                  	<div class="subheading">{{item.country_name}}</div>
			                </v-flex>

			                <v-flex xs12 sm6 class="pt-3">
			                	<label class="caption font-weight-light grey--text">State & City</label>
			                  	<div class="subheading">{{item.state_name}}, {{item.city_name}}</div>
			                </v-flex>

		              	</v-layout>
		            </v-container>
		          </v-card-text>

		          <v-card-actions v-if="editMode">
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" :disabled="processing" flat @click="editMode = false">Cancel</v-btn>
	                <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="updateProfile">Update</v-btn>
		          </v-card-actions>
		        </v-card>
		      </v-form>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    
    name: 'Profile',

    data () {
      	return {
	      	title: "My Profile",
	      	validForm: false,
	      	validPasswordForm: false,
	      	processing: false,
	        showPasswords: false,
	        passwordEditMode: false,
	        editMode: false,
	        readonly: true,
	        countries: [],
	        states: [],
	        cities: [],
	        item: {},
	        passwords: {},
	        fNameRules: [
	          	v => !!v || 'First Name is required',
	          	v => v && v.length >= 4 || 'Must be more than 3 characters',
	          	v => v && v.length <= 50 || 'Maximum 50 characters allowed'
	        ],
	        uNameRules: [
	          	v => !!v || 'Username is required',
	          	v => v && v.length >= 5 || 'Must be more than 4 characters',
	          	v => v && v.length <= 25 || 'Maximum 25 characters allowed'
	        ],
	        emailRules: [
	          	v => !!v || 'E-mail is required',
				v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
	          	v => v && v.length <= 50 || 'Maximum 50 characters allowed'
	        ],
	        passwordRules: [
	          	v => !!v || 'Password is required',
	          	v => v && v.length >= 5 || 'Must be more than 4 characters',
	          	v => v && v.length <= 20 || 'Maximum 20 characters allowed'
	        ],
	        mobileRules: [
	          	v => !!v || 'Mobile Number is required',
	          	v => v && v.length >= 10 || 'Must be 10 characters',
	          	v => v && v.length <= 10 || 'Maximum 10 characters allowed'
	        ],
	        requireRule: [
	        	v => !!v || 'Field is required'
	        ]
      	}
    },

    methods: {

    	getCountries () {
	        return this.axios.get(this.config.apis.getCountries)
    	},

    	getStates (country) {
	        this.processing = true
	        this.states = []
	        this.axios.get(this.config.apis.getStatesByCountry.replace(":country", country))
	        .then((response) => {
	            this.processing = false
	            if (this.isSuccessResponse(response)) {
	            	this.states = response.data.data
	            }
	        })
	        .catch((error) => {
	            this.processing = false
	        })
      	},

      	getCities (state) {
	        this.processing = true
	        this.cities = []
	        this.axios.get(this.config.apis.getCitiesByState.replace(":state", state))
	        .then((response) => {
	            this.processing = false
	            if (this.isSuccessResponse(response)) {
	            	this.cities = response.data.data
	            }
	        })
	        .catch((error) => {
	            this.processing = false
	        })
      	},

      	updateProfile () {
	      	this.processing = true
	        this.axios.put(this.config.apis.updateProfile, this.item)
          	.then((response) => {
            	if (this.isSuccessResponse(response)) {
              		this.notifySuccess('updateSuccess')
              		this.$store.commit('setUser', this.extend(this.item))
              		this.editMode = false
            	}
            	else{
              		this.notifyError('updateError')
            	}
            	this.processing = false
          	})
          	.catch((error) => {
            	this.processing = false
          	})
      	},

      	updatePassword () {
      		
      		if (this.passwords.old_password === this.passwords.new_password) {
      			this.notifyError('samePasswordsError')
      			return
      		}

      		if (this.passwords.new_password !== this.passwords.new_password1) {
      			this.notifyError('passwordsMismatch')
      			return
      		}

	        this.processing = true
	        this.axios.put(this.config.apis.updatePassword, this.passwords)
          	.then((response) => {
            	if (this.isSuccessResponse(response)) {
              		this.notifySuccess('resetPasswordSuccess')
              		this.passwordEditMode = false
              		this.passwords = {}
            	}
            	else{
              		this.notifyError('resetPasswordError')
            	}
            	this.processing = false
          	})
          	.catch((error) => {
            	this.processing = false
          	})
      	}

    },

    created () {
    	let breadcrumbs = [
	      	{
	          	text: 'Dashboard',
	          	disabled: false,
	          	href: '/dashboard'
	        },
	        {
	          	text: 'My Account',
	          	disabled: true
	        },
	        {
	          	text: 'Profile',
	          	disabled: true
	        }
       	]

       	this.$store.commit('setBreadcrumbs', breadcrumbs)
       	this.$store.commit('setPageTitle', 'My Profile')
    },

    mounted () {

    	this.processing = true
    	Promise.all([this.getCountries()])
		.then(([ countriesResponse ]) => {
		    this.processing = false
            this.countries = this.isSuccessResponse(countriesResponse) ? countriesResponse.data.data : []
		})
        .catch((error) => {
            this.processing = false
        })

        this.item = this.extend(this.loggedInUser)

    },

    watch: {

      	'item.country': function(val, oldVal){
            if (val && val != oldVal) {
                this.getStates(val)
            }
        },
      	'item.province': function(val, oldVal){
            if (val && val != oldVal) {
                this.getCities(val)
            }
        }
    },

    computed: {
    	fullname () {
	        let fullname = ""
	        if (this.isLoggedIn) {
	          fullname = this.loggedInUser.first_name
	          if (this.loggedInUser.last_name) {
	            fullname += " " + this.loggedInUser.last_name
	          }
	        }
	        return fullname
	    }
    }

  }
</script>
